import React, { useContext } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import color from '../config/Colors';
import LogoIconWithName from './LogoIconWithName';
import { Avatar, Stack, Typography } from '@mui/material';
import LanguageSelect from './LanguageSelect';
import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { AuthContext } from '../hooks/useAuth';
import { DrawerContext } from '../pages/dashboardLayout/useDrawer';
import LogoutIcon from '../assets/images/UserMenuIcon';

type Props = {
    // changeIsShowDrawer: () => void;
    isShowLabelAccount: boolean;
};
const ZIndex = 9999;

export default function MyAppBar(props: Props) {
    const classes = style();
    const { account, userAvatar } = useContext(AuthContext);

    const { setOpenDrawerSmall, isMobileSM } = useContext(DrawerContext);

    return (
        <AppBar
            position="static"
            sx={{ position: 'fixed', zIndex: ZIndex, width: '100vw', top: 0, background: color.appBarColor }}
        >
            <Toolbar>
                <Stack flexDirection={'row'} justifyContent={'space-between'} width={'100%'}>
                    <Stack flexDirection={'row'}>
                        {isMobileSM ? (
                            <IconButton
                                size="large"
                                edge="start"
                                color="inherit"
                                aria-label="menu"
                                sx={{ mr: 2 }}
                                onClick={() => setOpenDrawerSmall(true)}
                            >
                                <MenuIcon style={{ color: color.white }} />
                            </IconButton>
                        ) : (
                            ''
                        )}
                        <LogoIconWithName />
                    </Stack>

                    {isMobileSM ? (
                        ''
                    ) : (
                        <Stack
                            flexDirection={'row'}
                            className={classes.styleLanguageTop}
                            sx={{
                                '& .MuiSvgIcon-root': {
                                    color: color.grey600,
                                    px: '5px',
                                },
                                '& .MuiInputBase-input': {
                                    pr: '35px !important',
                                },
                            }}
                        >
                            <LanguageSelect isShowLabel={false} />
                            {props.isShowLabelAccount && (
                                <Box>
                                    <Typography
                                        variant="body1"
                                        align="center"
                                        color={color.white}
                                        display={'inline-block'}
                                        minWidth={80}
                                    >
                                        {account ? account?.firstName + ' ' + account?.lastName : 'Admin'}
                                    </Typography>
                                    <IconButton
                                        size="large"
                                        aria-label="account of current user"
                                        aria-controls="menu-appbar"
                                        aria-haspopup="true"
                                        color="inherit"
                                    >
                                        {userAvatar ? (
                                            <Avatar
                                                sx={{ width: '32px', height: '32px' }}
                                                alt={account?.firstName?.toUpperCase() || 'A'}
                                                src={userAvatar}
                                            />
                                        ) : (
                                            <LogoutIcon />
                                        )}
                                    </IconButton>
                                </Box>
                            )}
                        </Stack>
                    )}
                </Stack>
            </Toolbar>
        </AppBar>
    );
}

const style = makeStyles((theme: Theme) => ({
    styleLanguageTop: {
        '& .MuiSelect-select': {
            background: 'rgba(255, 255, 255, 0.1)',
            borderRadius: '3px',

            '& .MuiTypography-root': {
                display: 'none',
            },
            '&:focus': {
                background: 'rgba(255, 255, 255, 0.1) !important',
            },
        },
    },
}));
